import React from 'react'
import PropTypes from 'prop-types'
import Categories from './hurtonCategories/CategoryList'
import { connect } from 'react-redux'
import {
    addHurtonCategoryToProduct,
    removeHurtonCategoryFromProduct,
} from '../../../actions/HurtonCategoriesActions'

const Context = ({
    addCategory,
    categories,
    removeCategory,
    selectedCategories,
    title,
    productId,
    fetchingSelectedCategories,
}) => {
    return (
        <>
            {Object.values(categories).length > 0 && (
                <Categories
                    title={title}
                    addCategory={(/** @type {number} */ categoryId) =>
                        addCategory(productId, categoryId)
                    }
                    removeCategory={(/** @type {number} */ categoryId) =>
                        removeCategory(productId, categoryId)
                    }
                    selectedCategories={selectedCategories}
                    categories={categories}
                    loading={fetchingSelectedCategories}
                />
            )}
        </>
    )
}

Context.propTypes = {
    addCategory: PropTypes.func.isRequired,
    categories: PropTypes.objectOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
        })
    ).isRequired,
    removeCategory: PropTypes.func.isRequired,
    selectedCategories: PropTypes.arrayOf(PropTypes.number).isRequired,
    title: PropTypes.string,
    productId: PropTypes.number.isRequired,
    fetchingSelectedCategories: PropTypes.bool.isRequired,
}

Context.defaultProps = {
    selectedCategories: [],
    fetchingSelectedCategories: false,
}

const mapStateToProps = ({ presto }) => {
    const { hurtonCategories } = presto
    const { product } = presto.product.data

    const selectedCategories = presto.product.hurtonCategories.items
    const fetchingSelectedCategories = presto.product.hurtonCategories.fetching
    const productId = product.id

    return {
        categories: hurtonCategories.items,
        selectedCategories,
        fetchingSelectedCategories,
        productId,
    }
}

export default connect(mapStateToProps, {
    addCategory: addHurtonCategoryToProduct,
    removeCategory: removeHurtonCategoryFromProduct,
})(Context)
